<template>
  <Container class="container--main">
    <Title tag="h2" class="is-centered">Panel de monitoreo interno</Title>

    <Modal :showModal="isModalOpen" @close="closeModal">
      <template #header>
        <h5>{{ modalTitle }}</h5>
      </template>
      <template #body>
        <img
          v-if="modalContent !== false"
          class="modal__img"
          :src="modalContent"
          :alt="modalTitle"
          :onerror="
            `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
          "
          :broken="
            `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
          "
        />
        <div v-else>
          <div
            v-for="(event, index) in disEvents[0].events.slice().reverse()"
            :key="index"
          >
            <button class="show_event" v-on:click="showEvent(event.event)">
              {{ getDateFormat(event.event) }}
            </button>
            <img
              v-if="imgEvent === event.event"
              class="modal__img"
              :src="IMG_PATH + '/' + event.event"
            />
          </div>
        </div>
      </template>
    </Modal>

    <Title tag="h4" theme="secondary">Estación Meteorológica</Title>
    <div class="cards">
      <div v-for="variable in variables" :key="variable.name" class="card">
        <div class="card__title">
          <span v-html="variable.name"></span>
        </div>
        <div class="card__img">
          <img
            v-on:click="openModal(variable.url, variable.name)"
            :src="variable.url"
            :title="variable.name"
            :alt="variable.name"
            :onerror="
              `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
            "
            :broken="
              `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
            "
          />
        </div>
      </div>
    </div>

    <!-- Sección: Disdrometro -->
    <Title tag="h4" theme="secondary" class="pt-6">Disdrómetro óptico</Title>
    <div class="cards">
      <div
        v-for="disdrometro in disdrometros"
        :key="disdrometro.name"
        class="card"
      >
        <div class="card__title">
          <span v-html="disdrometro.name"></span>
        </div>
        <div class="card__img">
          <img
            v-on:click="openModal(disdrometro.url, disdrometro.name)"
            :src="disdrometro.url"
            :title="disdrometro.name"
            :alt="disdrometro.name"
            :onerror="
              `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
            "
            :broken="
              `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
            "
          />
        </div>
      </div>
    </div>

    <!-- Sección: Sophy -->
    <Title tag="h4" theme="secondary" class="pt-6"
      >Disdrometro Proyecto SOPHY</Title
    >
    <div class="cards">
      <div v-for="eventSophy in sophy" :key="eventSophy.name" class="card">
        <div class="card__title">
          <span v-html="eventSophy.name"></span>
        </div>
        <div class="card__img">
          <img
            v-on:click="openModal(eventSophy.url, eventSophy.name)"
            :src="eventSophy.url"
            :title="eventSophy.name"
            :alt="eventSophy.name"
            :onerror="
              `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
            "
            :broken="
              `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
            "
          />
        </div>
        <button
          v-on:click="openModal(false, 'Historial de eventos')"
          class="card__button"
          v-if="eventSophy.name === 'Eventos de precipitación'"
        >
          Ver historial de eventos
        </button>
      </div>
    </div>
  </Container>
</template>
<script>
import { ref, onMounted } from "vue";
import { DateTime } from "luxon";

import Container from "@/components/ui/objects/Container";
import Modal from "@/components/common/Modal.vue";
import Title from "@/components/ui/atoms/Title";

export default {
  components: {
    Modal,
    Container,
    Title,
  },
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    const basePath_images = process.env.VUE_APP_TEST_IMAGE;
    const currentDate = new Date().getTime();
    const IMG_PATH =
      "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/SOPHY_EVENTS_WEBP";
    const eventsJsonUrl = `https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/SOPHY_EVENTS_WEBP/imagenes.json?t=${currentDate}`; // Agrega timestamp para evitar caché
    const disEvents = ref([]);
    const imgEvent = ref(null);
    const lastEvent = ref(null);

    onMounted(async () => {
      try {
        const response = await fetch(eventsJsonUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const events = data.map((event) => ({
          event,
        }));
        disEvents.value.push({
          events,
        });
        lastEvent.value = events.slice().reverse()[0];
        imgEvent.value = lastEvent.value.event;
      } catch (error) {
        console.error("Error al obtener los eventos:", error);
      }
    });

    return {
      basePath,
      basePath_images,
      currentDate,
      eventsJsonUrl,
      disEvents,
      IMG_PATH,
      imgEvent,
      lastEvent,
    };
  },
  data() {
    return {
      modalTitle: "",
      modalContent: "",
      isModalOpen: false,
      image: null,
      variables: [
        {
          name: "Precipitación acumulada horaria (mm/h)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_rainfall_hourly.webp",
        },
        {
          name: "Velocidad del viento (m/s)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_meteo_windvelo.webp",
        },
        {
          name: "Dirección del viento",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_meteo_windrose.webp",
        },
        {
          name: "Temperatura 2m (°C)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_meteo_temp2m.webp",
        },
        {
          name: "Humedad Relativa 2m (%)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_meteo_relhum2m.webp",
        },
        {
          name: "Presión atmosférica 2m (hPa)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Ndays_meteo_press2m.webp",
        },
      ],
      disdrometros: [
        {
          name: "Control de Operatividad",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Control_Cantidad_Parsivel.webp",
        },
        {
          name: "Precipitación horaria acumulada (mm h<sup>-1</sup>)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Parsivel_Hourly_Realtime.webp",
        },
        {
          name: "Eventos de precipitación",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/events_pp.webp",
        },
      ],
      sophy: [
        {
          name: "Control de Operatividad",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/SOPHY_RESULTS/Control_Cantidad_Parsivel.webp",
        },
        {
          name: "Precipitación horaria acumulada (mm h<sup>-1</sup>)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/SOPHY_RESULTS/Parsivel_Hourly_Realtime.webp",
        },
        {
          name: "Eventos de precipitación",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/SOPHY_RESULTS/Last_Event.webp",
        },
      ],
    };
  },

  methods: {
    getDateFormat(date) {
      const justDate = date.replace(".webp", "");
      const dt = justDate.replace(/_/g, "-");
      const dtFormat = DateTime.fromISO(dt).setLocale("es");
      return dtFormat.toFormat("dd 'de' MMMM 'de' yyyy");
    },
    openModal(img, title) {
      this.modalTitle = title;
      this.modalContent = img;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.imgEvent = this.lastEvent.event;
    },

    showEvent(eventName) {
      this.imgEvent = this.imgEvent === eventName ? null : eventName;
    },
  },
};
</script>
<style lang="scss" scoped>
.image-background {
  display: flex;
  justify-content: center;
}
img {
  cursor: pointer;
}
.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
}

@media (max-width: 768px) {
  .cards {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

.card {
  border: 1px solid #ccc;
  border-radius: 5px;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card__title {
  background-color: #0099ff;
  color: white;
  padding: 0.5em;
  text-align: center;
  width: 100%;
}

.card__button {
  background-color: #0099ff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 0.5em;
  cursor: pointer;
  margin: 1em;
}

.card__button:hover {
  background-color: #007acc;
}

.card__btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0099ff;
  color: white;
  border-radius: 100%;
  opacity: 0.5;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.card__img {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.card__img > img {
  width: 100%;
  height: 200px;
  object-fit: contain;
  object-position: center;
  transition-duration: 200ms;
  transition-property: scale;
  transition-timing-function: ease-in-out;
}

.card__img > img:hover {
  scale: 105%;
  transition-duration: 200ms;
  transition-property: scale;
  transition-timing-function: ease-in-out;
}

.card__content > p {
  padding: 0.5em;
}

.modal__img {
  width: 100%;
  height: 100%;
  max-height: 750px;
  object-fit: contain;
  object-position: center;
}

.pt-6 {
  padding-top: 3rem;
}

.show_event {
  border: none;
  border-bottom: 2px solid #ccc;
  padding: 0.5em;
  width: 100%;
  cursor: pointer;
  margin: 0.4rem;
  text-align: left;
}

.show_event:hover {
  border-color: #0099ff;
}

.show_event:focus {
  border-color: #0099ff;
}
</style>
